import React from 'react';
import { Col, Row } from 'antd';
import BrandTopSubHeaderComponent from '../../components/Brand/Common/BrandTopSubHeaderComponent';
import BrandBaseLayoutComponent from '../../components/Layout/Brand/BrandBaseLayoutComponent';
import CreditDetailsComponent from '../../components/Brand/Credit/CreditDetailsComponent';
import { useGlobalState } from '../../store/state';
import CreditBankDetailsComponent from '../../components/Brand/Credit/CreditBankDetailsComponent';
import PendingPaymentsComponent from '../../components/Brand/Credit/PendingPaymentsComponent';
import TranscationHistoryComponent from '../../components/Brand/Credit/TranscationHistoryComponent';

export const BrandCreditPage = () => {
  const [user] = useGlobalState('user');

  return (
    <BrandBaseLayoutComponent>
      <BrandTopSubHeaderComponent className="px-3 py-2 sticky">
                Hello <strong>{`${user.firstname} ${user.lastname}`}</strong>
        <p className="m-0"
          style={{ fontSize: '0.8rem' }}>Welcome to your wallet</p>
      </BrandTopSubHeaderComponent>
      <div className="p-3">
        <Row gutter={16}>
          <Col span={24}>
            <div className="pt-3">
              <PendingPaymentsComponent/>
            </div>
          </Col>
          <Col span={24}>
            <div className="pt-3">
              <TranscationHistoryComponent/>
            </div>
          </Col>
        </Row>
      </div>
    </BrandBaseLayoutComponent>
  );
};
